import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';

/**
 * @typedef {{}} ProgrammationProps
 */

/**
 * Programmation Programmation.
 * @augments {Base<ProgrammationProps>}
 */
export default class Programmation extends withBreakpointObserver(Base) {
  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'Programmation',
    refs: ['tabs[]', 'containers[]', 'reset'],
    options: {
      activeBreakpoints: {
        type: String,
        default: 'xxs xs s',
      },
    },
  };

  /**
   * Reset all states
   */
  onResetClick() {
    this.$refs.containers.forEach((element) => {
      element.classList.remove('hidden');
    });

    this.currentContainer = null;
    this.currentTabs = null;

    this.switchTabs();

    this.$refs.reset.classList.add('bg-yellow');
  }

  /**
   * When clicking on main nav, switch or open menu
   * @param {object} props Props
   * @param {object} props.target Current element
   * @param {object} props.index Current index
   * @returns {void}
   */
  onTabsClick({ index, target }) {
    this.currentContainer = this.$refs.containers[index];
    this.currentTabs = target;
    this.$refs.reset.classList.remove('bg-yellow');

    this.switchTabs();
    this.switchContainers();
  }

  /**
   * Switch tabs states
   */
  switchTabs() {
    this.$refs.tabs.forEach((element) => {
      if (element !== this.currentTabs) {
        element.classList.remove('bg-yellow');
      } else {
        element.classList.add('bg-yellow');
      }
    });
  }

  /**
   * Switch Containers states
   */
  switchContainers() {
    this.$refs.containers.forEach((element) => {
      if (element !== this.currentContainer) {
        element.classList.add('hidden');
      } else {
        element.classList.remove('hidden');
      }
    });
  }
}
